import * as React from "react";
import { hot } from "react-hot-loader";

import classNames from "classnames";

import { IPCSInputProps, ITerm } from "./IPCSInputProps";
import { IPCSInputState } from "./IPCSInputState";

declare var libelle: any;
var choicesN1: any;


class PCSInput extends React.Component<IPCSInputProps, IPCSInputState> {

  constructor(props: any) {
    super(props);   

    // Construction des balises <option> pour initialiser les valeurs de la listeN1
    choicesN1 = this.props._terms.map((choice, key) => {
      return (
        <option key={key} value={choice.TermName}>{choice.TermName}</option>
      );
    });
    // R�cup�ration de la valeur saisie dans le champ SP de la listeN1
    let n1Value = "";
    let n2Value = ""
    if (this.props.init !== undefined) {
        let valeurs: string[] = this.props.init(this.props.inputListeSP);
        n1Value = valeurs[0];
        n2Value = valeurs[1];
    }
    // Construction des valeurs des listeN2 et listeN3 (� partir de n1Value et n2Value)
    const listeN2 = this.refreshListeN2ByN1(n1Value);
    const listeN3 = this.refreshListeN3ByN2(n2Value);

    this.state = {
      N1selected: n1Value,
      N2choices: listeN2,
      N2selected: n2Value,
      N3choices: listeN3
    };

    this.chargeN2byN1 = this.chargeN2byN1.bind(this);
    this.chargeN3byN2 = this.chargeN3byN2.bind(this);
  }    


  // EL : chargement de la liste N2 � partir de la valeur s�lectionn�e dans la liste N1
  private chargeN2byN1(event) {
    const n1 = event.target.value;
    const listeN2 = this.refreshListeN2ByN1(n1);

    this.setState({
      N1selected: n1,
      N2choices: listeN2,
      N2selected: "",
      N3choices: libelle.formulaireCandidature.DetailPCSMessage
    });
    if (this.props.onChange !== undefined) {
        this.props.onChange(event);
    }  
  }

  // EL : chargement de la listeN3 � partir de la valeur s�lectionn�e dans la liste N2
  private chargeN3byN2(event) {
    const n2 = event.target.value;
    const listeN3 = this.refreshListeN3ByN2(n2);

    this.setState({
      N1selected: this.state.N1selected,
      N2choices: this.state.N2choices,
      N2selected: n2,
      N3choices: listeN3
    });
    if (this.props.onChange !== undefined) {
        this.props.onChange(event);
    }
  }


  // EL : permet de rafra�chir les valeurs de listeN2 � partir d'une valeur s�lectionn�e dans listeN1
  private refreshListeN2ByN1(value: string):string {
      let listeN2 = "";
      if (value != "") {
        this.props._terms.forEach(terme => {
          if (terme.TermName == value) {
            terme.ChildTerms.map(child => {
              listeN2 += child.TermName + ";";
            });
          }
        });
      }
      return listeN2;
  }

  // EL : permet de rafra�chir les valeurs de listeN3 � partir d'une valeur s�lectionn�e dans listeN2
  private refreshListeN3ByN2(value: string): string {
    let listeN3 = libelle.formulaireCandidature.DetailPCSMessage;
    if (value != "") {
      listeN3 = "";
      this.props._terms.forEach(terme => {
        terme.ChildTerms.map(childN2 => {
          if (childN2.TermName == value) {
            childN2.ChildTerms.map(childN3 => {
              listeN3 += childN3.TermName + ";";
            })
          }
        });
      });
      if (listeN3 == "") {
        listeN3 = libelle.formulaireCandidature.DetailPCSVide;
      }
    }
    return listeN3;
  }

  public render() {       

    const controlClassN1 = classNames('form-control collapse show',
      { 'is-invalid': this.state.N1selected == "", 'is-valid': this.state.N1selected != "" }
    );
    const controlClassN2 = classNames('form-control collapse show',
      { 'is-invalid': this.state.N2selected == "", 'is-valid': this.state.N2selected != "" }
    );
    const styleN2N3 = this.state.N1selected == "" ? { display: 'none' } : {};

    return (
      <div className="form-group">
        <span>         
          <select className={controlClassN1} id={this.props.inputListeSP[0]} placeholder={this.props.CustomInputProps.InputForm.PlaceHolder}
            value={this.state.N1selected} name={this.props.inputListeSP[0]} disabled={this.props.CustomInputProps.InputForm.IsReadOnly}
            onChange={this.chargeN2byN1}
            autoComplete={this.props.CustomInputProps.InputForm.DisabledAutoComplet ? 'off' : ''} >
            <option key="N1Default" value=""></option>
            {choicesN1}
          </select>
        </span>

        <span>{this.state.N1selected != "" ? libelle.formulaireCandidature.sousCategoriePCS : ""}
          <select className={controlClassN2} id={this.props.inputListeSP[1]} placeholder={this.props.CustomInputProps.InputForm.PlaceHolder}
            value={this.state.N2selected} name={this.props.inputListeSP[1]} style={styleN2N3} disabled={this.props.CustomInputProps.InputForm.IsReadOnly}
            onChange={this.chargeN3byN2}
            autoComplete={this.props.CustomInputProps.InputForm.DisabledAutoComplet ? 'off' : ''} >
            <option key="N2Default" value=""></option>
            {this.state.N2choices.split(";").map((value, key) => {
              return (
                <option key={key} value={value}>{value}</option>
              );
            })
            }
          </select>
        </span>

        <a title={this.state.N3choices.split(";").join("\r")} style={styleN2N3}><img src="./assets/info_bulle.png" />{libelle.formulaireCandidature.DetailPCS}</a>

      </div>
    );

  }

}

export default hot(module)(PCSInput);
